import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import WcbQueueKeySelect from './WcbQueueKeySelect';
import { isSwedish } from '../../constants/languages';
import { getTranslation } from '../../constants/languages';

type WcbQueueKeyContainerProps = {
  iimclient: ConfigClientType;
  wcbQueueErrorVisible: boolean;
  changeSelectedQueue: Function;
};

/*
  This component was only visible in Swedish site when no segment
  was present and only had error messages translated to finnish
*/

const CallbackSelectedQueueValidationError = {
  lang_no: null,
  lang_se: 'Du måste välja ett ärende',
  lang_fi: 'Aihe pitää valita',
  lang_dk: null,
  lang_en: null,
};

const WcbQueueKeyContainer = ({
  iimclient,
  wcbQueueErrorVisible,
  changeSelectedQueue,
}: WcbQueueKeyContainerProps) => {
  const { lang, segment, callbackQueues } = iimclient;
  const showContainer = isSwedish(iimclient) && !segment && callbackQueues && callbackQueues.length;
  const translation = getTranslation(lang, CallbackSelectedQueueValidationError)
 
  return showContainer && (
    <div className="input-block wcb-queuekey-container helpinput">
      <label htmlFor="selectedQueueKey" id="callbackQueueKeyLbl">
        Välj ärende
      </label>
      <WcbQueueKeySelect
        iimclient={iimclient}
        changeSelectedQueue={changeSelectedQueue}
      />
      {wcbQueueErrorVisible && (
        <div className="validation-error" id="wcb-selectedqueue-error">
          <span className="validationerror">
            {translation}
          </span>
        </div>
      )}
    </div>
  );
};

export default WcbQueueKeyContainer;
